import { render, staticRenderFns } from "./ClientAiUsage.vue?vue&type=template&id=65b392fc&"
import script from "./ClientAiUsage.vue?vue&type=script&lang=js&"
export * from "./ClientAiUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports